module.exports = __webpack_public_path__ + "static/media/lastgoalscorer.221c0fb7.jpg";